/**
 * <PublicToolNav /> — minimal mobile-first top bar for public tool pages.
 *
 * Renders fixed at top with: CARTIEAI wordmark (links home), pricing link,
 * and a primary "Try Live Demo" CTA. Hidden on desktop md+ where pages have
 * their own headers; visible on small screens where users need an obvious
 * way back to the marketing site + a primary CTA always in reach.
 *
 * Iter27 audit caught this gap: /tools/ai-cost-calculator, /tools/finops-maturity,
 * /soc2 etc rendered without ANY nav on mobile — users got stuck without a
 * way back home (the BackToHomePill is small + easy to miss on a tiny screen).
 */
import React from 'react';
import { Link } from 'react-router-dom';

const PublicToolNav = () => (
  <div
    className="md:hidden fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-slate-950/85 border-b border-white/10"
    data-testid="public-tool-mobile-nav"
  >
    <div className="flex items-center justify-between px-4 py-2.5">
      <Link to="/" className="flex items-center gap-2 group" data-testid="public-tool-nav-home">
        <div className="w-7 h-7 rounded-md bg-emerald-400 bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-md shadow-emerald-500/40">
          <span className="text-white font-bold text-xs">C</span>
        </div>
        <span className="text-sm font-bold text-white">CARTIE<span className="text-emerald-400">AI</span></span><sup className="ml-0.5 text-[0.55em] font-bold text-emerald-300 align-super tracking-normal">™</sup>
      </Link>
      <div className="flex items-center gap-2">
        <Link to="/pricing" className="text-[11px] text-slate-300 hover:text-white px-2 py-1.5" data-testid="public-tool-nav-pricing">Pricing</Link>
        <Link
          to="/signup"
          className="text-[11px] font-semibold px-3 py-1.5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 shadow shadow-emerald-500/30"
          data-testid="public-tool-nav-cta"
        >
          Try free
        </Link>
      </div>
    </div>
  </div>
);

export default PublicToolNav;
